import React, { useEffect, useState } from 'react';
import styles from './FileInputTemplate.module.css';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import RemoveSvg from '@icons/Remove.svg';

import FileInput from '@images/fileinput.png';

const checkType = type => {
  if (['image/png', 'image/jpeg'].includes(type)) {
    return true
  }

  return false;
}

const FileInputTemplate = ({ childrenEl, setValue, error }) => {
  const { t } = useTranslation();
  const [over, setOver] = useState();
  const onClick = childrenEl.props.onClick;
  const value = childrenEl.props.children.props.value;
  const objectURL = value && URL.createObjectURL(value);

  const handleClick2 = (e) => {
    onClick(e);
  }

  useEffect(() => {
    if (!value) {
      return
    }

    if (!checkType(value.type)) {
      return;
    }

    setValue(value)
  }, [value])

  const handleClick = () => {
    onClick();
  }

  const handleOver = e => {
    e.preventDefault();

    setOver(true);

    return false;
  }

  const handleLeave = () => {
    setOver(false);
  }

  const handleDrop = e => {
    e.preventDefault();

    const file = e.dataTransfer.files[0];

    if (!checkType(file.type)) {
      return;
    }

    setValue(file);
  }

  const handleRemove = () => {
    setValue(undefined);
  }

  return (
    <div className={styles.wrapper} onDrop={handleDrop} onDragOver={handleOver} onDragLeave={handleLeave}>
      {!value && (
        <div className={cn(styles.withoutValue, over && styles.over, error && styles.errorWrapper)}>
          <img src={FileInput} className={styles.image} />

          <div className={styles.text}>
            {t('fileinput.descrtiption')}<span className={cn(styles.link, childrenEl.props.disabled && styles.disabled)} onClick={handleClick}>{t('fileinput.download')}</span>
          </div>

          <div className={styles.description}>
            PNG, JPG, JPEG
          </div>

          {error && (
            <div className={styles.error}>
              {error}
            </div>)
          }
        </div>
      )}

      {value && (
        <>
          <div className={styles.imageWrapper}>
            <div className={styles.imageOverflow}>
              <img src={objectURL} className={styles.imagePreview} onClick={handleClick2} />
            </div>

            <div className={styles.remove} onClick={handleRemove}>
              <img src={RemoveSvg} />
            </div>
          </div>
          
          {error && (
            <div className={styles.errorImage}>
              {error}
            </div>)
          }
        </>
      )}
    </div>
  )
}

export default FileInputTemplate;
